import { Trash2, FileText, Download } from "lucide-react";
import { Button } from "./ui/button";

const fmtBytes = (bytes = 0) => {
  if (!bytes || isNaN(bytes)) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const val = (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1);
  return `${val} ${units[i]}`;
};

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString();
  } catch {
    return iso;
  }
};

const Badge = ({ children }) => (
  <span className="inline-flex items-center rounded-md border px-2 py-[2px] text-xs bg-white">
    {children}
  </span>
);

const Empty = () => (
  <div className="flex flex-col items-center justify-center rounded-md border border-dashed py-10 text-center">
    <FileText className="h-6 w-6 mb-2 text-gray-400" />
    <p className="text-sm text-gray-500">No course materials yet.</p>
  </div>
);

const CourseMaterialsList = ({ items = [], onRemove }) => {
  if (!Array.isArray(items) || items.length === 0) return <Empty />;

  return (
    <div className="space-y-3">
      {items.map((m) => (
        <div
          key={m._id}
          className="flex items-start justify-between rounded-md border p-3"
        >
          <div className="flex items-start gap-3">
            <div className="mt-[2px]">
              <FileText className="h-5 w-5 text-secondary" />
            </div>

            <div className="space-y-1">
              <div className="flex flex-wrap items-center gap-2">
                <h4 className="font-medium text-secondary break-all">
                  {m.title || m.originalName || "Untitled"}
                </h4>
                {m.format ? <Badge>{m.format.toUpperCase()}</Badge> : null}
                {m.mimeType ? <Badge>{m.mimeType}</Badge> : null}
                {m.bytes ? <Badge>{fmtBytes(m.bytes)}</Badge> : null}
              </div>

              <div className="text-xs text-gray-500">
                Uploaded: {fmtDate(m.uploadedAt || m.createdAt)}
              </div>

              <div className="flex items-center gap-2 pt-1">
                {m.url ? (
                  <a
                    href={m.url}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 text-sm underline"
                  >
                    <Download className="h-4 w-4" />
                    View / Download
                  </a>
                ) : null}
              </div>
            </div>
          </div>

          <div className="shrink-0">
            <Button
              variant="destructive"
              onClick={() => onRemove && onClickSafe(onRemove, m)}
              className="inline-flex items-center gap-2 text-red-500"
            >
              <Trash2 className="h-4 w-4" />
              Remove
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

const onClickSafe = (fn, payload) => {
  try {
    fn(payload);
  } catch (e) {
    // no-op: parent can handle toast/logging
    console.error(e);
  }
};

export default CourseMaterialsList;
